import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import theme from '../../../styles/theme';
import useForm from '../../../hooks/useForm';

import { Text, TextButton, Textarea } from '../../atoms';

const FormWrapper = styled.form`
  display: block;
`;

const SubmitWrapper = styled.div`
  margin-top: ${theme.spacing.xs};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CHANNEL_ID = '6182c2ce41316567ffd9bcaa';

const PostForm = ({
  initialValue,
  placeholder,
  helperText,
  height,
  onSubmit,
  ...props
}) => {
  const { values, errors, isLoading, handleChange, handleSubmit } = useForm({
    initialValue,
    onSubmit: async (values) => {
      await onSubmit({ ...values, channelId: CHANNEL_ID });
    },
    validate: ({ title }) => {
      const errors = {};

      if (!title) {
        errors.title = '내용을 입력해주세요.';
      }

      return errors;
    },
  });

  return (
    <FormWrapper {...props} onSubmit={handleSubmit}>
      <Textarea
        placeholder={placeholder}
        name="title"
        height={height}
        value={values.title}
        onChange={handleChange}
      />
      <SubmitWrapper>
        <Text
          size="sm"
          color={
            errors.title && !isLoading
              ? theme.colors.error
              : theme.colors.gray600
          }
        >
          {isLoading ? `업로드 중....` : errors.title || helperText}
        </Text>
        <TextButton type="submit" disabled={isLoading}>
          제출하기
        </TextButton>
      </SubmitWrapper>
    </FormWrapper>
  );
};

PostForm.propTypes = {
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
  onSubmit: PropTypes.func,
  initialValue: PropTypes.object,
  height: PropTypes.string,
};

PostForm.defaultProps = {
  placeholder: '',
  helperText: '',
  onSubmit: () => {},
  initialValue: {
    title: '',
    image: null,
  },
  height: undefined,
};

export default PostForm;
